import { lazy, useContext, useMemo } from "react";
import type {
  FlightClientAssetProps,
  FlightModuleFeatureFlag,
} from "@hopper-b2b/types";
import { SlotProvider, type Slots } from "@hopper-b2b/ui";
import type { FeatureFlagsContextProps } from "@hopper-b2b/utilities";
import type { Theme } from "@material-ui/core";
import { UserContext } from "../../App";
import ClientLogo from "../../assets/client/client-logo.svg";
import { flightCheckoutProps } from "../../modules/flight-checkout";
import { useDarkModePreferred } from "../../utils/colors";
import { apiConfig } from "../../utils/urlPaths";
import { darkModeIcons, lightModeIcons } from "./sharedIcons";
// TODO: Check why lodging is still importing these styles
import "../../nubank.index.scss";

const FlightsApp = lazy(() => import("@hopper-b2b/flights"));

interface INubankRoute {
  theme: Theme;
  featureFlags: FeatureFlagsContextProps;
  slots: Slots;
}

const FlightsRouteComponent = ({
  theme,
  featureFlags,
  slots,
}: INubankRoute) => {
  const { sessionInfo } = useContext(UserContext);
  const isDarkMode = useDarkModePreferred();

  const flightAppClientAssets: FlightClientAssetProps = useMemo(
    () => ({
      logo: ClientLogo,
      featureFlag: {
        enableA11yMode: true,
      } as FlightModuleFeatureFlag,
      assets: isDarkMode ? darkModeIcons : lightModeIcons,
    }),
    [isDarkMode]
  );

  return (
    <SlotProvider slots={slots}>
      <FlightsApp
        checkoutProps={{ ...flightCheckoutProps, sessionInfo }}
        apiConfig={apiConfig}
        clientAssets={flightAppClientAssets}
        featureFlags={{
          ...featureFlags,
          // Wallet is only available for hotels
          enableWallet: false,
          enableCoreFintechMarketplace: true,
          enableFintechSelection: true,
        }}
        theme={theme}
      />
    </SlotProvider>
  );
};

export default FlightsRouteComponent;
